export const AdminCampaignCostDashboards = {
  AdminCampaignCostDashboards: {
    permissionsId: "cc899969-ca78-44e5-7047-08dbf65badbd",
    permissionsName: "Campaign Cost",
    description: null,
    componentsId: null,
    components: null
  },
};
